import React from 'react';

type AppAuthenticationStateAuthenticated = {
  isAuthenticated: true;
  jwtToken: string;
  refreshToken: string;
  user: {
    id: string;
    username: string;
    firstname: string;
    lastname: string;
  };
};

export type AppAuthenticationState =
  | AppAuthenticationStateAuthenticated
  | {
      isAuthenticated: false;
    };

const defaultState: AppAuthenticationState = {
  isAuthenticated: true,
  jwtToken: 'not real',
  refreshToken: 'xxxx',
  user: {
    id: '1',
    username: 'fn100373',
    firstname: 'Thore',
    lastname: 'Roepman',
  },
};

const context = React.createContext<
  [AppAuthenticationState, React.Dispatch<React.SetStateAction<AppAuthenticationState>>]
>([defaultState, () => {}]);

export default function AppAuthenticationContextProvider(props: React.PropsWithChildren) {
  const [state, setState] = React.useState<AppAuthenticationState>(defaultState);

  return <context.Provider value={[state, setState]}>{props.children}</context.Provider>;
}

export function useAppAuthenticationState(): AppAuthenticationState {
  return React.useContext(context)[0];
}

export type AuthenticatedProps<T> = T & { authentication: AppAuthenticationStateAuthenticated };

export function makeAuthenticatedComponent<T>(
  componentFactory: React.FunctionComponent<T & { authentication: AppAuthenticationStateAuthenticated }>,
): React.FunctionComponent<T> {
  return function AuthenticatedAssertion(props: T) {
    const state = useAppAuthenticationState();

    if (state.isAuthenticated) {
      return componentFactory({ ...props, authentication: state });
    }
    return <span>Requires login</span>;
  };
}
